export default "https://cdn-static.gokick.com/assets/75ac565edfb9d82dbbe43c50f72b37b3535e18ca/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";